<template>
    <label class="input-label" :style="labelStyle">
        <span :style="fontStyle" class="title" v-if="title != ''">{{title}}</span>
        <input :type="inputType" v-model="model" @change="changeInput" @blur="leaveInput" @keyup="inputMsg" class="msg" :style="inputStyle" :placeholder="placeholder" :maxlength="maxlength" v-if="needLength" @keydown="changeMsg"/>
        <input :type="inputType" v-model="model" @change="changeInput" @blur="leaveInput" @keyup="inputMsg" class="msg" :style="inputStyle" :placeholder="placeholder" v-if="!needLength" @keydown="changeMsg"/>
        <slot></slot>
    </label>
</template>
<script>
export default {
     data: function() {
         return {
             // model:''
         }
     },
     props:{
         title:{
             type: String,
             default:''
         },
         placeholder:{
             type: String,
             default:''
         },
         fontStyle: {
             type: Object,
             default:{
                 'color': 'rgba(51,51,51,0.90)',
                 'font-size': '14px',
                 'color': '#999',
                 'padding-right': '8px'
             }
         },
         inputStyle:{
             type: Object,
             default:{
                 'width': '122px',
                 'height': '34px'
             }
         },
         inputType:{
             type: String,
             default: 'text'
         },
         model:{
             type: String,
             default:''
         },
         labelStyle:{
             type: Object,
             default: {}
         },
         maxlength:{
             type: Number,
             default: 25
         },
         needLength: {
             type: Boolean,
             default: true
         }

     },
     methods:{
         changeInput: function(){
             this.$emit('change-input', this.model);
         },
         leaveInput: function(){
             this.$emit('leave-input', this.model);
         },
         inputMsg: function(){
             this.$emit('input-msg', this.model);
         },
         changeMsg: function(e){
             if (e.keyCode == 13){
                 this.$emit('change-msg', this.model);
             }
         }
     }
}
</script>
<style lang="scss" scoped>
    .input-label{
        .title{
            float: left;
            margin-top: 8px;

        }
        .msg{
            display: inline;
            padding-left: 8px;
            border: 1px solid #DADADA;
            border-radius: 4px;
            color: #333;

        }
        .msg::-webkit-input-placeholder{
            color: #999;
        }
        input {
            appearance:none;
            -moz-appearance:none; /* Firefox */
            -webkit-appearance:none; /* Safari 和 Chrome */
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/input/input.vue